import { FC, ReactNode } from 'react'
import { UserState } from '@/states'

const Profile: FC = (): ReactNode => {
    const { User } = UserState()

    return (
        <div className='py-3 px-4'>
            <span className='block text-sm font-bold text-[#EBEBEB]'>
                {User?.Name}
            </span>

            <span className='block text-sm text-[#CDD5DA] truncate'>
                {User?.Email}
            </span>
        </div>
    )
}

export default Profile
